// file to interface with the global smi object and store instance

// NOTE: we should only import types from smi-core so that it doesn't get bundled with cancel-flows
import type {
  track as trackType,
  notify as notifyType,
  request_pause_subscription as requestPauseSubscriptionType,
  request_change_product as requestChangeProductType,
  request_delete_item as requestDeleteItemType,
  request_cancel_subscription as requestCancelSubscriptionType,
  request_apply_retention_discount as requestApplyRetentionDiscountType,
  dayjs as dayjsType
} from '@ordergroove/smi-core';
import { type State } from '@ordergroove/smi-store/types';
import { Action, Store } from 'redux';

export const getSmi = () => {
  if (!window.og?.smi) {
    throw new Error('smi-core not loaded. Ensure cancel-flow loads after smi-core.');
  }
  return window.og.smi;
};

export const getStore = () => getSmi().store as unknown as Store<State, Action<string>>;
/** Avoid using this utility directly; prefer calling `useTrack` which will automatically retrieve the selected cancelReason from context */
export const track: typeof trackType = (event, attributes) =>
  getSmi().track(event, { ...attributes, triggeredBy: 'cancelFlow' });
export const notify: typeof notifyType = (...args) => getSmi().notify(...args);
export const dayjs: typeof dayjsType = (...args) => getSmi().dayjs(...args);

// In preview mode, smi-preview provides a store with no saga middleware, so dispatching these actions has no effect —
// there are no saga watchers running to handle them and make network requests.
export const requestPauseSubscription: typeof requestPauseSubscriptionType = (...args) =>
  getSmi().request_pause_subscription(...args);
export const requestChangeProduct: typeof requestChangeProductType = (...args) =>
  getSmi().request_change_product(...args);
export const requestDeleteItem: typeof requestDeleteItemType = (...args) => getSmi().request_delete_item(...args);
export const requestCancelSubscription: typeof requestCancelSubscriptionType = (...args) =>
  getSmi().request_cancel_subscription(...args);

export const requestApplyRetentionDiscount: typeof requestApplyRetentionDiscountType = (...args) =>
  getSmi().request_apply_retention_discount(...args);
